const style = {
  pageTitleWrapper: {
    borderRadius: 2,
  },
  tabPaper: {
    borderRadius: 0,
  },
};

export default style;
